// Backend host (HTTPS for REST, WSS for WebSocket).
// Override at build time:
//   VITE_AIVOX_BACKEND=https://api.aivox.app npm run build
// Default fallback is the canonical production backend host. The previous
// raw Railway URL was wrong — broke QR PWA in prod when VITE_AIVOX_BACKEND
// env wasn't set on Vercel. Patent Claim 4 prod dependency (2026-05-12).
const RAW = (import.meta.env.VITE_AIVOX_BACKEND ?? 'https://aivox-api.spotmind.co').replace(/\/+$/, '');

export const BACKEND_HTTP = RAW;
export const BACKEND_WS = RAW.replace(/^http/i, 'ws');

export const SESSION_LOOKUP_PATH = '/v1/aivox/broadcast/sessions';
export const LISTEN_WS_PATH = '/v1/aivox/broadcast/listen';

export const LANGUAGE_LABELS: Record<string, string> = {
  'en-US': 'English',
  'en-GB': 'English (UK)',
  'zh-HK': '廣東話',
  'zh-TW': '繁體中文',
  'zh-CN': '简体中文',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'es-ES': 'Español',
  'fr-FR': 'Français',
  'de-DE': 'Deutsch',
  'it-IT': 'Italiano',
  'pt-BR': 'Português',
  'ru-RU': 'Русский',
  'ar-SA': 'العربية',
  'hi-IN': 'हिन्दी',
  'th-TH': 'ไทย',
  'vi-VN': 'Tiếng Việt',
  'id-ID': 'Bahasa Indonesia',
};

export function languageLabel(code: string): string {
  return LANGUAGE_LABELS[code] ?? code;
}
